import { createMutationHelper } from '@utils/swr'
import { type PaymentTransactionRequest } from '../types/apiRequest'
import { type ECommerceV2Apis } from '../types/apis'

const { useMutation } = createMutationHelper<ECommerceV2Apis['get']['paymentTransactionCancelable'], Record<string, never>, PaymentTransactionRequest>({
  client: 'eCommerceV2',
  key: '/:countryCode/payment_transactions',
  fetcher: (_, { arg, client }) => {
    return client.get(`/${arg.country_code}/payment_transactions/${arg.id}/cancelable`)
  },
})

export const useECommerceGetPaymentTransactionCancelable = useMutation
